module.exports = __webpack_public_path__ + "static/img/Laurie-Daley.33f5771.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Laurie-Daley.jpg
// module id = W1gY
// module chunks = 0